<template>
  <div class="automotive-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="automotive-content">
      <h4 class="automotive-h4 indent" id="automotive-1">Overview</h4>
      <p class="automotive-p indent">Aluminium is a strong, durable and lightweight metal. In today’s energy-conscious society, these three basic properties combine to make the metal the preferred material of construction for transport applications, where weight reduction to reduce fuel consumption and to increase load carrying capacity is vital.</p>
      <p class="automotive-p indent">At Alcomet we manufacture customized extrusion solutions as well as a wide range of rolled products, such as aluminium foil, sheets and coils for all branches of the automotive industry.</p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_1.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-2">Strips for heat shields</h4>
      <p class="automotive-p indent">With its specific physical properties – reflectivity, thermal conductivity and corrosion resistance – aluminium is the perfect heat shield material offering excellent protection against excessive exhaust system heat. Alloy 1050A in soft temper is widely used for its good formability, adequate corrosion resistance and energy absorption providing for ease of fabrication and good performance.</p>
      <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_2.jpg' + ')'}"></div>
      <h4 class="automotive-h4 indent" id="automotive-3">Automotive finstock</h4>
      <p class="automotive-p indent">Aluminium has a unique set of characteristics that make it ideal for heat exchange. With its key properties – light weight, good thermal and electrical conductivity and corrosion resistance aluminium finstock has a widespread application in modern HVAC (Heating, Ventilation and Air Conditioning) and refrigeration systems.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_3.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-4">Roof rails</h4>
      <p class="automotive-p indent">An important application of aluminium extrusions are roof rails. Roof rails are placed on the top of the vehicle and are used to carry additional luggage and equipment. Aluminium extrusions are used for manufacturing roof rails because they enable visually attractive, low weight and high strength designs.</p>
      <h4 class="automotive-h4 indent" id="automotive-5">Decorative trims</h4>
      <p class="automotive-p indent"><span class="strong">Trim</span> is anything the manufacturer applies to the car to enhance its style and appearance. Decorative and functional strips around the vehicle are an integral part of vehicle design. Depending on the applied alloy, the different processing options lead to surfaces ranging from high-gloss to matte and from natural-colored to black aluminum.</p>
      <p class="automotive-p indent">Consequently, aluminium is increasingly the material of choice for high quality decorative display and design purposes in the interior of today’s cars.</p>
      <p class="automotive-p indent">In its extrusion plant Alcomet is able to extrude a large variety of profiles for automotive applications according to your design.</p>
      <router-link class="automotive-link" to="/contacts/factory-location">Contact us with your enquiry today</router-link>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_4.jpg' + ')'}"></div> -->
      <h4 class="automotive-h4 indent" id="automotive-6">Heat exchangers</h4>
      <p class="automotive-p indent">Aluminum is the preferred material for the increasingly diverse and demanding field of heat exchanger manufacture, and is used around the world in many industries, including the automotive sector, for a variety of heat exchanger designs. Aluminum provides a unique combination of advantages, e.g. its cost, strength, corrosion life, weight reduction capabilities, processing and machining characteristics, and the ability to alloy special material properties to specific customer applications.</p>
      <!-- <div class="automotive-img" :style="{backgroundImage: 'url(' + '/static/img/markets/automotive/img_5.jpg' + ')'}"></div> -->
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["automotive-1", "Overview"],
        ["automotive-2", "Strips for heat shields"],
        ["automotive-3", "Automotive finstock"],
        ["automotive-4", "Roof rails"],
        ["automotive-5", "Decorative trims"],
        ["automotive-6", "Heat exchangers"],
      ]
    };
  }
};
</script>

<style scoped>
.automotive-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.automotive-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.automotive-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.automotive-link {
  font-size: 19px;
  text-decoration: underline;
}
.automotive-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.automotive-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .automotive-content {
    width: 100%;
  }
  .automotive-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .automotive-link {
    font-size: 16px;
  }
  .automotive-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Automotive.vue